export default __webpack_public_path__ + "static/news_1600-0f4c3820c7e7883e6eea01e5a6eeed3c.jpg";